/**
 * What the donations ledger says about a gift's reconciled Stripe fee and
 * its disputes (docs/Decisions.md D59). Pure, so it is unit-tested.
 */
import { formatMoney } from './payments';

/**
 * One line for the gift's fee adjustment, or null before the charge's fee is
 * known or when the estimate was exact.
 */
export function feeAdjustmentNote(donation) {
  const adjustment = donation?.fees?.adjustmentCents;
  if (!Number.isInteger(adjustment) || adjustment === 0) return null;
  return adjustment > 0
    ? `Stripe fee ${formatMoney(adjustment)} above estimate, added to your invoice`
    : `Stripe fee ${formatMoney(-adjustment)} below estimate, credited on your invoice`;
}

const DISPUTE_STATUS = {
  warning_needs_response: 'needs a response',
  needs_response: 'needs a response',
  warning_under_review: 'under review',
  under_review: 'under review',
  warning_closed: 'closed',
  won: 'won',
  lost: 'lost',
};

/** One line for the latest dispute on the gift, or null. */
export function disputeNote(donation) {
  const disputes = Array.isArray(donation?.disputes) ? donation.disputes : [];
  if (!disputes.length) return null;
  const latest = disputes[disputes.length - 1];
  return `Disputed: ${DISPUTE_STATUS[latest.status] || latest.status || 'open'}`;
}
